module.exports = __webpack_public_path__ + "img/stickers-attestation-honneur.22da7901.jpg";